import { z } from "zod/v4";
import { seasonPlanItemSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export const plan = {
	list: () => fetchApi(`/plan`, z.array(seasonPlanItemSchema)),
	get: (id: string) => fetchApi(`/plan/${id}`, seasonPlanItemSchema),
	create: (body: any) =>
		fetchApi(`/plan`, seasonPlanItemSchema, { method: "POST", body: JSON.stringify(body) }),
	update: (id: string, body: any) =>
		fetchApi(`/plan/${id}`, seasonPlanItemSchema, { method: "PUT", body: JSON.stringify(body) }),
	remove: (id: string) =>
		fetchApi(`/plan/${id}`, z.object({ deleted: z.boolean() }), { method: "DELETE" }),
};
